import React, { useState } from 'react'
import { IconButton, Step, StepLabel, Stepper } from '@material-ui/core'
import GroupRegistrationStore from './Store/GroupRegistrationStore'
import { GroupRegEl, QontoConnector } from './Elements'
import { Portal } from 'react-portal'
import { withStoreProvider } from '../../../../../../Helpers/withStoreProvider'
import CloseIcon from '@material-ui/icons/Close'
import { H3 } from '../../../../../../Styles/typography'
import { Subscribe } from 'unstated'
import CourseStore from '../../../../Store/CourseStore'
import { getGroupRegState } from './Config'
import Button from '../../../../../../Components/Buttons/Button'
import Batch from './Components/Batch'
import ClassTimings from '../../../../../../Modules/ClassTimings/ClassTimings'

function GroupRegistration({
  onSubmit,
  close,
  batches,
  withAuditionVid,
  withApproval,
  mode,
  pendingGroupEnrollment = false,
}) {
  const { activeStep } = GroupRegistrationStore.useContainer()
  const [steps, getActiveComp] = getGroupRegState(withAuditionVid, withApproval)
  const [loading, setLoading] = useState(false)

  return (
    <Subscribe to={[CourseStore]}>
      {({ state: { name, userType } }) => (
        <Portal>
          <GroupRegEl onClick={() => close()}>
            <div className='regModal' onClick={(e) => e.stopPropagation()}>
              <div className='close'>
                <IconButton onClick={() => close()}>
                  <CloseIcon />
                </IconButton>
              </div>
              {mode === 'REGISTER' ? (
                <>
                  <H3>{name} Registration</H3>
                  {steps?.length > 1 && (
                    <Stepper
                      alternativeLabel
                      activeStep={activeStep}
                      connector={<QontoConnector />}
                    >
                      {steps.map((label, i) => (
                        <Step key={`${label}-${i}`}>
                          <StepLabel>{label}</StepLabel>
                        </Step>
                      ))}
                    </Stepper>
                  )}
                  <div className='modalContent'>
                    {getActiveComp(activeStep, {
                      batches,
                      onSubmit,
                      withAuditionVid,
                      withApproval,
                      pendingGroupEnrollment,
                    })}
                  </div>
                </>
              ) : mode === 'PENDING' ? (
                <>
                  <H3>Requested batch for {name}</H3>
                  <div className='modalContent pendingRequestContent'>
                    <Batch withAction={false} batch={batches} />
                    <H3>You can cancel this request to send another.</H3>
                    <Button
                      onClick={() => {
                        setLoading(true)
                        onSubmit('', batches.id)
                      }}
                      name={'Cancel Request'}
                      type={'primary'}
                      disabled={loading}
                      loading={loading}
                    />
                  </div>
                </>
              ) : (
                mode === 'ENROLLED' && (
                  <>
                    <H3>Registered batch for {name}</H3>
                    <div className='modalContent enrolledContent'>
                      <ClassTimings userType={userType} />
                    </div>
                  </>
                )
              )}
            </div>
          </GroupRegEl>
        </Portal>
      )}
    </Subscribe>
  )
}

export default withStoreProvider([GroupRegistrationStore])(GroupRegistration)
